import { BulkDomainSearchSelectedTldListView } from '.'
import { BulkDomainSearchTldView } from './tld.view'

export class BulkDomainSearchTldListView {
  private el: HTMLElement

  constructor(
    el: HTMLElement,
    selectedTldListView: BulkDomainSearchSelectedTldListView
  ) {
    this.el = el

    const tldEls = el.querySelectorAll<HTMLAnchorElement>(
      '.js-domain-search__bulk-tld'
    )

    tldEls.forEach((tldEl) => {
      new BulkDomainSearchTldView(tldEl, selectedTldListView)
    })
  }

  public show(): void {
    this.el.classList.remove('hidden')
  }

  public hide(): void {
    this.el.classList.add('hidden')
  }
}
